import React, { useState, useEffect } from "react";
import { Download, X, Share } from "lucide-react";
import { Button } from "@/components/ui/button";

export const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showIos, setShowIos] = useState(false);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("pv_install_dismissed") === "1");

  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setDeferredPrompt(e); };
    window.addEventListener("beforeinstallprompt", handler);
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isIos && !isStandalone) setShowIos(true);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") setDeferredPrompt(null);
  };

  const dismiss = () => { setDismissed(true); localStorage.setItem("pv_install_dismissed", "1"); };

  if (dismissed || (!deferredPrompt && !showIos)) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-50 bg-dark-paper border border-purple-500/30 rounded-xl p-4 shadow-2xl shadow-purple-900/40 animate-fade-in-up" data-testid="install-prompt-banner">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-lg bg-purple-700 flex items-center justify-center flex-shrink-0"><Download className="w-4 h-4 text-white" /></div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm mb-0.5">Install Promptviser</p>
          {deferredPrompt ? (
            <p className="text-xs text-white/50 mb-2">Add the app to your home screen for instant access.</p>
          ) : (
            <p className="text-xs text-white/50 mb-2 flex items-center gap-1 flex-wrap">Tap <Share className="w-3 h-3 inline text-purple-300" /> then "Add to Home Screen" in Safari.</p>
          )}
          <div className="flex gap-2">
            {deferredPrompt && <Button onClick={install} size="sm" className="bg-purple-700 text-white hover:bg-purple-600 text-xs h-7" data-testid="install-app-btn">Install App</Button>}
            <Button onClick={dismiss} variant="ghost" size="sm" className="text-white/40 text-xs h-7" data-testid="install-dismiss-btn">Not now</Button>
          </div>
        </div>
        <button onClick={dismiss} className="text-white/30 hover:text-white"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};

export default InstallPrompt;
